import { createSelector } from '@reduxjs/toolkit';
const getMinicart = (state) => state.minicart.minicart;
export const minicartQuantitySelector = createSelector([getMinicart], (minicart) => minicart === null || minicart === void 0 ? void 0 : minicart.numItems);
export const isUserAuthenticated = (state) => state.userInfo;
